import { vservice } from '@niknevis/vue-modules'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { ContentItemGetDataForCompleteResourceModel } from '@/modules/content-item/models/content-item-resource.model'
import { Data } from '@/modules/shared/models/data'

@vservice()
export class AdminContentItemGetDataForCompleteUseCase {
  constructor(
    private readonly service: AdminContentItemService
  ) {
  }

  public remoteData = RemoteData
    .notAsked<Data<ContentItemGetDataForCompleteResourceModel>>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get data(): ContentItemGetDataForCompleteResourceModel {
    return this.remoteData.fold(
      () => null,
      value => value.data || null,
      value => value.data,
      (error, value) => value || null
    )
  }

  execute(contentItem: number) {
    return this.remoteData.fromPromise(
      this.service.getDataForComplete(contentItem)
    )
  }
}